import React from 'react'
import * as styles from './index.module.css'
import { GatsbyImage } from 'gatsby-plugin-image'
import { GradientBorder } from '../commons'
import Button from '../Button/'
import ArrowDown from '../../../assets/images/ArrowDown.svg'
import Link from '../Link'

const Os2Pricing = (props) => {
  return (
    <div className="wrapper">
      <div className={styles.container}>
        <GradientBorder height="1px" className={styles.gradBorder} />
        <div className={styles.pricingBox}>
          <GatsbyImage
            image={props.images[0].gatsbyImageData}
            className={styles.frontImage}
            imgStyle={{ objectFit: 'contain' }}
            alt={props.images[0].description}
          />
          <div className={styles.pricingText}>
            <div className={`${styles.title} h2`}>OS2</div>
            <div className={styles.subtext}>
              {props.subtitle.subtitle.split('\n').map((line, idx) => (
                <div key={idx}>{line}</div>
              ))}
            </div>
            <div className={styles.ttsContainer}>
              <Link to={props.ctaUrl}>
                <Button className={styles.tts} style={{ width: '304px' }}>
                  {props.ctaText}
                </Button>
              </Link>
              <Link to={props.components[0].ctaUrl} target="_blank">
                <Button
                  className={styles.dl}
                  inverted
                  style={{ width: '304px' }}
                >
                  {props.components[0].ctaText}
                  <ArrowDown
                    style={{
                      display: 'inline',
                      alignSelf: 'center',
                      position: 'relative',
                      left: '10px',
                    }}
                  />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Os2Pricing
